import { useEffect } from 'react';
import { useMicrophone } from '../../contexts/MicrophoneContext';

const MicrophonePermission = ({ onPermissionGranted, onPermissionDenied, showPrompt = false }) => {
  const { 
    permissionState, 
    error,  
  } = useMicrophone();
  
  // Don't auto-request permission - only request when explicitly triggered
  // This component now only handles permission state changes and notifications

  // Notify parent components of permission state changes
  useEffect(() => {
    if (permissionState === 'granted' && onPermissionGranted) {
      onPermissionGranted();
    } else if (permissionState === 'denied' && onPermissionDenied) {
      onPermissionDenied(error);
    }
  }, [permissionState, onPermissionGranted, onPermissionDenied, error]);

  // Don't render anything - this component only handles permission requests silently
  return null;
};

export default MicrophonePermission;
